/** 带「已驳回」/驳回类审核标签的主色（列表、审核记录等统一） */
export const REVIEW_REJECT_LABEL_COLOR = '#de5a50'
export const REVIEW_REJECT_LABEL_BG = '#fef0f0'
export const REVIEW_REJECT_LABEL_BORDER = '#de5a50'
